import { isResponsePending } from "@onestore/onestore-store-common/http"
import { useAppSelector } from "~/store/hooks"
import type { AppState } from "~/store/reducer"

export default function useButtonLoadingState(buttonId: string) {
  const buttons = useAppSelector((state: AppState) => state.basket.buttons)

  return isResponsePending(buttons[buttonId])
}
